import { AuthEmployeeResponseData, OrganizationTypeEnum } from "schema"

import { canSeeSubscription } from "./canSeeSubscription"

export function canSeeReferrals(
  employee?: AuthEmployeeResponseData,
  activeSubscriptionName?: string,
) {
  if (!employee || !canSeeSubscription(employee)) {
    return false
  }

  if (employee.organization.type !== OrganizationTypeEnum.Client) {
    return false
  }

  const planKey = activeSubscriptionName?.split("_").at(-1)

  return planKey !== "free"
}
